import { RootState } from '../reducers';

export const authSelector = (state: RootState): boolean => state.session.isAuthenticated;
